<template>
    <div id="app">
        <div class="independentPage" v-if="$route.meta.independentPage">
            <router-view/>
        </div>
        <div class="pageBox noIndependentPage" v-else>
            <el-container>
                <el-header>
                    <el-dropdown>
                        <i class="el-icon-user-solid" style="margin-right: 15px"></i>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item>
                                <el-button type="text" @click="logout()">退出</el-button>
                            </el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                    <span>{{currentSystemLoginUserName}}</span>
                </el-header>
                <el-container>
                    <!--侧边栏-->
                    <el-aside width="15%">
                        <el-menu :default-active="$route.path" >
                            <div v-for="item in menuList" :key="item.route">
                                <el-menu-item @click="toPage(item)" :index="item.route" class="menu-listTit">
								<span slot="title">
								  <i :class="item.iconClass"></i>
								  {{item.name}}
								</span>
                                </el-menu-item>
                            </div>
                        </el-menu>
                    </el-aside>
                    <el-main>
                        <router-view/>
                    </el-main>
                </el-container>
            </el-container>
        </div>
    </div>
</template>

<script>
    import VueCookies from 'vue-cookies'

    export default {
		data: function() {
			return {
			    currentSystemLoginUserName: '',
				menuList: [ //菜单列表
					{
						name: 'app管理',
						route: '/app',
						iconClass: 'el-icon-s-shop',
					},
					{
						name: '动态配置',
						route: '/dynamicResource',
						iconClass: 'el-icon-message',
					},
					{
						name: '玉符配置',
						route: '/configuration',
						iconClass: 'el-icon-s-tools',
					},
					{
						name: '远程配置',
						route: '/remoteConfig',
						iconClass: 'el-icon-setting',
					},
					{
						name: '玉符工具',
						route: '/tools',
						iconClass: 'el-icon-link',
					},
				]
			}
		},
        mounted: function(){
		    this.getCurrentSystemLoginUser()
        },
        methods: {
            // 退出按钮
            logout: function () {
                const self = this;
                self.$confirm('此操作会退出该系统，是否继续？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                })
                    .then(() => {
                        self.logoutFn();
                    })
                    .catch(() => {
                    });
            },
            // 退出事件
            logoutFn: function () {
                const self = this;
                // 删除cookie
                let keys = VueCookies.keys();
                for (let key in keys) {
                    VueCookies.remove(keys[key]);
                }
                self.$router.push({
                    path: '/'
                })
                // self.$axios_api.logout({}).then( res => {
                // 	// 删除cookie
                // 	let keys = VueCookies.keys();
                // 	for (let key in keys) {
                // 		VueCookies.remove(keys[key]);
                // 	}
                // 	self.$router.push({
                // 		path: '/'
                // 	});
                // })
            },

            toPage: function (item) {
                if (item.route !== '') {
                    this.$router.push({
                        path: item.route
                    });
                }
			},
            getCurrentSystemLoginUser: function () {
                this.$axios_api.getCurrentSystemLoginUser({}).then( res => {
                    this.currentSystemLoginUserName = res;
                })
            }
        }
    }
</script>

<style>
    html, body {
        margin: 0;
        padding: 0;
        width: 100%;
        height: 100%;
    }
    #app {
        height: 100%;
        width: 100%;
        text-align: center;
    }
    .independentPage {
        height: 100%;
        width: 100%;
    }
    .el-header {
        background-color: #B3C0D1;
        color: #333;
        line-height: 60px;
        text-align: right;
        font-size: 12px
    }
    .el-aside {
        color: #333;
        background-color: rgb(238, 241, 246)
    }
    .noIndependentPage{
        height: 100%;
        width: 100%;
        display: flex;
    }
</style>
